import React from 'react';

/**
 * Shared meta-label used on Surah and Juz cards.
 * Renders "SURAH 96" or "JUZ 1" with a consistent typography
 * and number badge across all card types and themes.
 */
const CardMetaLabel = ({ label, number }) => (
  <p
    className="flex items-center gap-2 text-xs uppercase tracking-wider font-semibold mb-4"
    style={{ color: 'var(--text-secondary)' }}
  >
    {label}
    <span
      className="px-1.5 py-0.5 rounded text-xs font-bold"
      style={{
        background: 'var(--card-index-bg)',
        color: 'var(--card-index-text)',
      }}
    >
      {number}
    </span>
  </p>
);

export default CardMetaLabel;
